import { RenderingProps, TranslationOptionsParams } from 'src/shared/shared.types';

export interface N11BreadcrumbOneLevelPageItem {
  name?: string;
  navigationTitle?: {
    value?: string;
  };
  url?: {
    path?: string;
  };
}

export interface N11BreadcrumbOneLevelFields {
  data?: {
    currentPage?: {
      parent?: N11BreadcrumbOneLevelPageItem;
    };
  };
}

export type N11BreadcrumbOneLevelParams = TranslationOptionsParams;

export type N11BreadcrumbOneLevelProps = RenderingProps<
  N11BreadcrumbOneLevelFields,
  N11BreadcrumbOneLevelParams
>;
